import type { TagProps } from "@site-types/components/tag"

export function Tag({ data }: TagProps) {
  if (data.length === 0) return null
  return (
    <ul className="m-auto list-none px-0 pt-[1.5rem] pb-[10rem] md:max-w-[800px] md:pt-[3rem] lg:max-w-[950px] lg:pt-[2rem] xl:max-w-[1150px] xl:pt-[1.5rem]">
      {data.map((tag) => (
        <li
          className="m-[3px] inline-block bg-[var(--white)] px-[15px] py-[3px] font-bold text-[1.2em] text-[var(--deep-blue)] leading-[1.8em] [--clip-inset:7.5px] [clip-path:polygon(0%_0%,calc(100%-var(--clip-inset))_0%,100%_var(--clip-inset),100%_100%,var(--clip-inset)_100%,0%_calc(100%-var(--clip-inset)))] max-sm:max-w-[calc(100vw-var(--side-menu-width)-5rem)] max-sm:whitespace-normal max-sm:leading-[1.35em] md:text-[1.6em] max-sm:[overflow-wrap:anywhere]"
          key={tag}
        >
          {tag}
        </li>
      ))}
    </ul>
  )
}

export default Tag
